// ==========================================================================
// Ajustements sur GRANDEURS SIGNÉES — passe « grandeurs signées ».
//
// Un facteur multiplicatif n'a pas de sens sur une grandeur signée exprimée en
// points (marge, croissance, ROIC) : sur une base NÉGATIVE, ×1.2 DÉGRADE au
// lieu d'améliorer — le scénario « optimiste » d'une société déficitaire
// rendait sa marge plus négative. Deux corrections DISTINCTES, selon la nature :
//   • hypothèses en points (marge, croissance, ROIC) → écart ADDITIF ;
//   • fourchette autour d'un milieu signé → écart proportionnel à |milieu|.
// ==========================================================================

// Hypothèses de MODÉLISATION — pas des constantes techniques. Centralisées,
// nommées et commentées pour être visibles et discutables (comme les primes
// terminales rendues paramètres), plutôt qu'enfouies dans les expressions. À
// externaliser (UI / import) si un réglage par dossier s'impose.
export const MODELING = {
  // Marge d'exploitation cible du modèle de convergence, à l'import :
  //   cible = marge de base + uplift (en points).
  targetMarginUpliftPts: 0.05,
  // ⚠ AUCUN plafond de marge. Une société logicielle mature dépasse 40 % de
  // marge — c'est EXACTEMENT la grandeur en jeu dans l'arbitrage de marge
  // terminale (backlog D1). Un plafond ici la contraindrait EN SILENCE avant
  // même que la décision soit prise. Ne pas réintroduire de cap sur la marge.
  scenario: {
    // Écarts de scénario en POINTS pour les grandeurs SIGNÉES (peuvent être < 0).
    dcf: { marginPts: 0.05, growthInitialPts: 0.05, growthInitialCap: 0.50 },
    exc: { roicPts: 0.03, roicCapOpt: 0.35, roicCapTerm: 0.30 },
    // (croissance terminale, WACC, discount, royalty, attrition restent
    //  multiplicatifs : grandeurs ≥ 0 par nature, le facteur y garde son sens.)
  },
};

// Écart additif en points, bornes optionnelles. Se comporte identiquement quel
// que soit le signe : base −0,32 + 0,05 = −0,27 (améliore vers zéro), là où
// −0,32 × 1,20 = −0,38 (dégrade).
export function shiftPts(base, deltaPts, { cap = null, floor = null } = {}) {
  let v = (base ?? 0) + deltaPts;
  if (cap != null) v = Math.min(v, cap);
  if (floor != null) v = Math.max(v, floor);
  return v;
}

// Fourchette autour d'un point milieu SIGNÉ. mid × 1,15 / × 0,85 INVERSE la
// fourchette quand mid < 0 (le « haut » passe sous le « bas »). On écarte par
// |mid| × spread puis on TRIE pour garantir low ≤ mid ≤ high quel que soit le
// signe. Les bornes explicites (low/high non nulles) priment sur la dérivation.
export function bandFromMid(mid, low = null, high = null, spread = 0.15) {
  const lo = low != null ? low : mid - Math.abs(mid) * spread;
  const hi = high != null ? high : mid + Math.abs(mid) * spread;
  const [a, b] = [lo, hi].sort((x, y) => x - y);
  return { low: a, mid, high: b };
}
